import axios from 'axios';
import store from '../store';
import { logout, refreshToken } from '../reducers/userReducer';
import { isJwtExpired } from 'jwt-check-expiration';

const tokenValidatorAxios = axios.create();

let refreshPromise = null;

tokenValidatorAxios.interceptors.request.use(async (config) => {
  let token = localStorage.getItem('token');
  const refreshTokenValue = localStorage.getItem('refreshToken');

  const isTokenExpired = !token || isJwtExpired(token);
  const isRefreshTokenExpired = !refreshTokenValue || isJwtExpired(refreshTokenValue);

  if (isTokenExpired) {

    if (isRefreshTokenExpired) {
      console.error('[Interceptor] Refresh token is expired');
      store.dispatch(logout());
      throw new Error('Session expired');
    }

    // If no refresh is in progress, start one
    if (!refreshPromise) {
      refreshPromise = store.dispatch(refreshToken())
        .then((res) => {
          if (refreshToken.fulfilled.match(res)) {
            return res.payload.access_token;
          } else {
            throw new Error(res.payload?.message || 'Token refresh failed');
          }
        })
        .catch((err) => {
          console.error('[Interceptor] Error during refresh:', err);
          store.dispatch(logout());
          throw err;
        })
        .finally(() => {
          refreshPromise = null;
        });
    }

    // Await the refresh and get the new token before continuing
    try {
      token = await refreshPromise;
    } catch (err) {
      throw err; // Already logged and logout dispatched
    }
  }

  // Now set the (refreshed or valid) token in the header
  config.headers['x-auth-token'] = token;
  return config;
});

export default tokenValidatorAxios;